
import dust from "dustjs-linkedin";


(function(){dust.register("lessons/lesson-creator/editor/onboarding",body_0);function body_0(chk,ctx){return chk.write("<div class=\"content\"><h1>").helper("i18n",ctx,{},{"id":"course_wizard_text_input_title"}).write("</h1><p>").helper("i18n",ctx,{},{"id":"lessons_creator_editor_onboarding_text"}).write("</p><p><button class=\"example outline\" data-type=\"text\">").helper("i18n",ctx,{},{"id":"lessons_creator_editor_onboarding_example_button"}).write("</button></p></div>");}return body_0;})();

export default 0;
